module.exports = [
  {
    name: `Cat`,
    inputCss: `
.meow {
  color: orange;
}
    `,
    outputCss: `
.Cat_meow_j3xk {
  color: orange;
}
    `,
    outputJs: `
{
  meow: 'Cat_meow_j3xk'
}
    `,
    component: `
import React from 'react';
import styles from './Cat.css';

class Cat extends React.Component {
  render() {
    return (
      <div className={styles.meow}>
        Orange Cat
      </div>
    );
  }
}
export default Cat;
    `,
    html: `
<div class="Cat_meow_j3xk">Orange Cat</div>
    `
  },

  {
    name: `Widget1`,
    inputCss: `
.button {
  border-radius: 4px;
  background-color: LightCyan;
}
    `,
    outputCss: `
.Widget1_button_1FUOu {
  border-radius: 4px;
  background-color: LightCyan;
}
    `,
    outputJs: `
{
  button: "Widget1_button_1FUOu"
}
    `,
    component: `
import React from 'react';
import styles from './Widget1.css';

class Widget1 extends React.Component {
  render() {
    return (
      <button className={styles.button}>
        Click Me
      </button>
    );
  }
}
export default Widget1;
    `,
    html: `
<button class="Widget1_button_1FUOu">Click Me</button>
  `
  },

  {
    name: `Widget2`,
    inputCss: `
.title {
  font-weight: bold;
  font-size: 16px;
}

.email {
  padding: .5rem;
}

.submitButton {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.submitButton:hover {
  background-color: #2F79AD;
}
    `,
    outputCss: `
.Widget2_title_1co1k {
  font-weight: bold;
  font-size: 16px;
}

.Widget2_email_3rJVW {
  padding: .5rem;
}

.Widget2_submitButton_1lMZk {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.Widget2_submitButton_1lMZk:hover {
  background-color: #2F79AD;
}
    `,
    outputJs: `
{
  title: "Widget2_title_1co1k",
  email: "Widget2_email_3rJVW",
  submitButton: "Widget2_submitButton_1lMZk"
}
    `,
    component: `
import React from 'react';
import styles from './Widget2.css';

class Widget2 extends React.Component {
  render() {
    return (
      <div>
        <h2 className={styles.title}>
          Email Signup
        </h2>
        <input
          className={styles.email}
          placeholder="Email Please"
          />
        <br/>
        <button
          className={styles.submitButton}
          >
          Submit
        </button>
      </div>
    );
  }
}
export default Widget2;
    `,
    html: `
<div><h2 class="Widget2_title_1co1k">Email Signup</h2><input class="Widget2_email_3rJVW" placeholder="Email Please"><br><button class="Widget2_submitButton_1lMZk">Submit</button></div>
    `
  },

  {
    name: `Widget3`,
    inputCss: `
.button {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.button.disabled {
  background-color: #aaa;
  border-color: #999;
}
    `,
    outputCss: `
.Widget3_button_24Uk4 {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.Widget3_button_24Uk4.Widget3_disabled_2czCZ {
  background-color: #aaa;
  border-color: #999;
}
    `,
    outputJs: `
{
  button: "Widget3_button_24Uk4",
  disabled: "Widget3_disabled_2czCZ"
}
    `,
    component: `
import React from 'react';
import styles from './Widget3.css';
import cx from 'classnames';

class Widget3 extends React.Component {
  render() {
    return (
      <div>
        <button
          className={styles.button}
          >
          Click Me!
        </button>
        <br/>
        <button
          className={cx(
            styles.button,
            styles.disabled
          )}
          >
          Do Not Click Me
        </button>
      </div>
    );
  }
}
export default Widget3;
    `,
    html: `
<div><button class="Widget3_button_24Uk4">Click Me!</button><br><button class="Widget3_button_24Uk4 Widget3_disabled_2czCZ">Do Not Click Me</button></div>
    `
  },

  {
    name: `Widget4`,
    inputCss: `
.button {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.fun .button {
  font-weight: bold;
  background: linear-gradient(
    90deg,
    #ff0000, #ffff00,
    #00ff00, #00ffff,
    #ff00ff, #ff0000
  );
}
    `,
    outputCss: `
.Widget4_button_2Zuuj {
  padding: .5rem;
  margin-top: .5rem;
  border: 1px solid #2F79AD;
  border-radius: 4px;
  background-color: #6DB9EE;
}

.Widget4_fun_2c2WR .Widget4_button_2Zuuj {
  font-weight: bold;
  background: linear-gradient(
    90deg,
    #ff0000, #ffff00,
    #00ff00, #00ffff,
    #ff00ff, #ff0000
  );
}
    `,
    outputJs: `
{
  button: "Widget4_button_2Zuuj",
  fun: "Widget4_fun_2c2WR"
}
    `,
    component: `
import React from 'react';
import styles from './Widget4.css';

class Widget4 extends React.Component {
  render() {
    return (
      <div>
        <button
          className={styles.button}>
          Regular Button
        </button>
        <br/>
        <div className={styles.fun}>
          <button
            className={styles.button}
            >
            FUN BUTTON
          </button>
        </div>
      </div>
    );
  }
}
export default Widget4;
    `,
    html: `
<div><button class="Widget4_button_2Zuuj">Regular Button</button><br><div class="Widget4_fun_2c2WR"><button class="Widget4_button_2Zuuj">FUN BUTTON</button></div></div>
    `
  },

  {
    name: `Widget5`,
    utilInputCss: `
/* grapes are round and purple */
.grape {
  border: 2px solid #ff00ff;
  border-radius: 10px;
  background-color: purple;
  color: white;
}

.grape:hover {
  background-color: #ff00ff;
}
`,
    utilOutputCss: `
/* grapes are round and purple */
.util_grape_A_sa5 {
  border: 2px solid #ff00ff;
  border-radius: 10px;
  background-color: purple;
  color: white;
}

.util_grape_A_sa5:hover {
  background-color: #ff00ff;
}
`,
    inputCss: `
.button {
  composes: grape from './util.css';
  padding: .5rem;
  margin-top: .5rem;
}
    `,
    outputCss: `
.Widget5_button_1Aw-M {
  padding: .5rem;
  margin-top: .5rem;
}
    `,
    outputJs: `
{
  button: "Widget5_button_1Aw-M util_grape_A_sa5"
}
    `,
    component: `
import React from 'react';
import styles from './Widget5.css';

class Widget5 extends React.Component {
  render() {
    return (
      <button className={styles.button}>
        Button
      </button>
    );
  }
}
export default Widget5;
    `,
    html: `
<button class="Widget5_button_1Aw-M util_grape_A_sa5">Button</button>
    `
  },

  {
    name: `Widget6`,
    inputCss: `
input.large {
  font-size: 20px;
}

.medium input {
  font-size: 14px;
}

.tiny * {
  font-size: 9px;
}

/* Don't do this!
   This style will be global. */
input {
  padding: 0.5rem;
}
    `,
    outputCss: `
input.Widget6_large_1QsrJ {
  font-size: 20px;
}

.Widget6_medium_FwRDZ input {
  font-size: 14px;
}

.Widget6_tiny_2iJZp * {
  font-size: 9px;
}

/* Don't do this!
   This style will be global. */
input {
  padding: 0.5rem;
}
    `,
    outputJs: `
{
  large: "Widget6_large_1QsrJ",
  medium: "Widget6_medium_FwRDZ",
  tiny: "Widget6_tiny_2iJZp"
}
    `,
    component: `
import React from 'react';
import styles from './Widget6.css';

class Widget6 extends React.Component {
  render() {
    return (
      <div>
        <input
          className={styles.large}
          placeholder="I am large"
          />
        <div className={styles.medium}>
          <input placeholder="I am medium" />
        </div>
        <div className={styles.tiny}>
          <input placeholder="I am so tiny" />
        </div>
      </div>
    );
  }
}
export default Widget6;
    `,
    html: `
<div><input class="Widget6_large_1QsrJ" placeholder="I am large"><div class="Widget6_medium_FwRDZ"><input placeholder="I am medium"></div><div class="Widget6_tiny_2iJZp"><input placeholder="I am so tiny"></div></div>
    `
  },

  {
    name: `Widget7`,
    inputCss: `
.small {
  opacity: 0.2;
}
.large {
  opacity: 1.0;
}

@media (max-width: 600px) {
  .small {
    opacity: 1.0;
  }
  .large {
    opacity: 0.2;
  }
}
    `,
    outputCss: `
.Widget7_small_2tsQ- {
  opacity: 0.2;
}

.Widget7_large_1NLxE {
  opacity: 1.0;
}

@media (max-width: 600px) {
  .Widget7_small_2tsQ- {
    opacity: 1.0;
  }
  .Widget7_large_1NLxE {
    opacity: 0.2;
  }
}
    `,
    outputJs: `
{
  small: "Widget7_small_2tsQ-",
  large: "Widget7_large_1NLxE"
}
    `,
    component: `
import React from 'react';
import styles from './Widget7.css';

class Widget7 extends React.Component {
  render() {
    return (
      <div>
        <div className={styles.small}>
          The Window is Small
        </div>
        <div className={styles.large}>
          The Window is Big
        </div>
      </div>
    );
  }
}
export default Widget7;
    `,
    html: `
<div><div class="Widget7_small_2tsQ-">The Window is Small</div><div class="Widget7_large_1NLxE">The Window is Big</div></div>
    `
  }
];



// WEBPACK FOOTER //
// ./src/guides/css-modules-by-example/data.js